import { useState, useEffect } from "react";
import "../../dash.css";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db, applicantsCol } from "../../firebase";
import { useUser } from "../../UserContext";


export const Academic_info_fields = ({ onSuccess }) => {
  const { user, loading: userLoading } = useUser();
  const userID = user?.uid || "";
  const [level, setLevel] = useState("");
  const [degreeName, setDegreeName] = useState("");
  const [levelFrom, setLevelFrom] = useState("");
  const currentYear = new Date().getFullYear();
  const [isNewApplicant, setIsNewApplicant] = useState(true);
  const [hasSavedAcademicInfo, setHasSavedAcademicInfo] = useState(false);
  const [issavingData, setIssavingData] = useState(false);
  const [disableInputFields, setDisableInputFields] = useState(false);
  const [message, setMessage] = useState("");
  const [isErrorOrSuccMsg, setIsErrorOrSuccMsg] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [formData, setformData] = useState({
    level: "",
    levelFrom: "",
    formSixIndexNumber: "",
    yearCompletedFormSixOrAdvanced: "",
    nameOfInstituteCompletedDiploma: "",
    diplomaStartedYear: "",
    diplomaCompletedYear: "",
    nameOfInstituteCompletedDegree: "",
    degreeStartedYear: "",
    degreeCompletedYear: "",

  });
  const [loading, setIsloading] = useState(false);

  // get applicants details if aready registered
  useEffect(() => {
    if (!userID) return;
    const fetchApplicantDetails = async () => {
      setIsloading(true);
      const applicantRef = doc(db, applicantsCol, userID);

      const registeredApplicant = await getDoc(applicantRef);
      if (registeredApplicant.exists()) {
        setIsNewApplicant(false);
        const data = registeredApplicant.data();

        if (data.savedAcademicInfo) {
          setHasSavedAcademicInfo(true);
          setDisableInputFields(true);
          setformData((prev) => ({
            ...prev,
            level: data.level,
            levelFrom: data.levelFrom,
            formSixIndexNumber: data.formSixIndexNumber || "",
            yearCompletedFormSixOrAdvanced: data.yearCompletedFormSixOrAdvanced || "",
            nameOfInstituteCompletedDiploma: data.nameOfInstituteCompletedDiploma || "",
            diplomaStartedYear: data.diplomaStartedYear || "",
            diplomaCompletedYear: data.diplomaCompletedYear || "",
            nameOfInstituteCompletedDegree: data.nameOfInstituteCompletedDegree || "",
            degreeStartedYear: data.degreeStartedYear || "",
            degreeCompletedYear: data.degreeCompletedYear || "",
          }));
          setIsloading(false);
        } else {
          setIsloading(false);
          setHasSavedAcademicInfo(false);
          setDisableInputFields(false);
        }
      } else {
        setIsloading(false);
        setIsNewApplicant(false);
        setDisableInputFields(false);
      }
    };

    fetchApplicantDetails();
  }, [userID]);

  const handleChange = (e) => {
    setformData((prev) => ({
      ...prev,
      savedAcademicInfo: true,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIssavingData(true);

    try {
      if (isNewApplicant) {
        await setDoc(doc(db, applicantsCol, userID), formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setMessage("personal information saved successfully");
        setDisableInputFields(true);
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      } else {
        const applicantRef = doc(db, applicantsCol, userID);
        await updateDoc(applicantRef, formData);
        setIssavingData(false);
        setIsErrorOrSuccMsg(true);
        setIsErrorMsg(false);
        setDisableInputFields(true);
        hasSavedAcademicInfo ? setMessage("academic information updated successfully") : setMessage("academic information saved successfully");
        // if (typeof onSuccess === "function") {
        //   onSuccess();
        // }
      }
    } catch (error) {
      setIssavingData(false);
      setIsErrorOrSuccMsg(true);
      setIsErrorMsg(true);
      setMessage("something went wrong, try again");
    }
  };

  const enableFields = () => {
    setDisableInputFields(false);
    setIsErrorOrSuccMsg(false);
    setHasSavedAcademicInfo(false);
  };

  if (loading) return <div className="loader"></div>;

  return (
    <form className="form-container personal-info"  onSubmit={handleSubmit}>
      {isErrorOrSuccMsg ? (
        <div
          className={`alert alert-${isErrorMsg ? "danger" : "success"}`}
          role="alert"
        >
          {message}
        </div>
      ) : (
        <span></span>
      )}
      {disableInputFields ? (
        <button className="btn btn-primary" onClick={enableFields}>
          CHANGE
        </button>
      ) : (
        <span></span>
      )}
      <label htmlFor="level-select">Level:</label>
      <select
        id="level-select"
        value={formData.level}
        name="level"
        disabled={disableInputFields}
        onChange={e => handleChange(e)}
        // onChange={e => handleChange(e)}
        style={{ display: 'block', width: '100%', marginBottom: 16, padding: 8 }}
      >
        <option value={formData.level}>{formData.level==="degree" ? 'Bachelor Degree' : 'Masters Degree'}</option>
        <option value="degree" name="level">Bachelor Degree</option>
        <option value="masters" name="level">Masters Degree</option>
        {/* <option value="diploma">Diploma</option>
        <option value="certificate">Certificate</option> */}
      </select>

      {formData.level === "degree" && (
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="degree-name">from:</label>
          <select
            id="level-from-select"
            value={formData.levelFrom}
            name="levelFrom"
            disabled={disableInputFields}
            onChange={e => handleChange(e)}
            style={{ display: 'block', width: '100%', marginBottom: 16, padding: 8 }}
          >
            <option value="">Select from</option>
            <option value="advanced" name="levelFrom">Advanced</option>
            <option value="diploma" name="levelFrom">Diploma</option>
            {/* <option value="certificate">Certificate</option> */}
          </select>
        </div>
      )}
      {formData.levelFrom === "advanced" && (
        <div style={{ marginBottom: 16 }}>
          <div className="form-fields">
            <label>
              form six or advanced index number <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter form six index number"
              name="formSixIndexNumber"
              value={formData.formSixIndexNumber}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              required
              maxLength={255}
            />
              <label>
              year completed form six or advanced <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              name="yearCompletedFormSixOrAdvanced"
              value={formData.yearCompletedFormSixOrAdvanced}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              min="1900"
              max={currentYear}
              step="1"
              placeholder="e.g. 2020"
              pattern="[0-9]{4}"
              required
              style={{ width: '100%' }}
            />
            {disableInputFields ? (
              <span></span>
            ) : issavingData ? (
              <div className="loader"></div>
            ) : (
              <button
                type="submit"
                style={hasSavedAcademicInfo ? { background: "green" } : {}}
              >
                {hasSavedAcademicInfo ? "update" : "save"}
              </button>
            )}
          </div>
        </div>
      )}

      {formData.levelFrom === "diploma" && (
        <div style={{ marginBottom: 16 }}>
          <div className="form-fields">
            <label>
              name of institute  completed diploma <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter name of institute or university  completed diploma"
              name="nameOfInstituteCompletedDiploma"
              value={formData.nameOfInstituteCompletedDiploma}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              required
              maxLength={255}
            />
            <label>
             diploma started year <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              name="diplomaStartedYear"
              value={formData.diplomaStartedYear}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              min="1900"
              max={currentYear}
              step="1"
              placeholder="e.g. 2020"
              pattern="[0-9]{4}"
              required
              style={{ width: '100%' }}
            />
            <label>
              diploma completed year <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              name="diplomaCompletedYear"
              value={formData.diplomaCompletedYear}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              min="1900"
              max={currentYear + 5}
              step="1"
              placeholder="e.g. 2024"
              pattern="[0-9]{4}"
              required
              style={{ width: '100%' }}
            />
            {disableInputFields ? (
              <span></span>
            ) : issavingData ? (
              <div className="loader"></div>
            ) : (
              <button
                type="submit"
                style={hasSavedAcademicInfo ? { background: "green" } : {}}
              >
                {hasSavedAcademicInfo ? "update" : "save"}
              </button>
            )}
          </div>
        </div>
      )}


      {formData.level === "masters" && (
        <div style={{ marginBottom: 16 }}>
          <div className="form-fields">
            <label>
              name of institute  completed degree <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              placeholder="Enter name of institute or university  completed degree"
              name="nameOfInstituteCompletedDegree"
              value={formData.nameOfInstituteCompletedDegree}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              required
              maxLength={255}
            />
            <label>
             degree started year <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              name="degreeStartedYear"
              value={formData.degreeStartedYear}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              min="1900"
              max={currentYear}
              step="1"
              placeholder="e.g. 2020"
              pattern="[0-9]{4}"
              required
              style={{ width: '100%' }}
            />
            <label>
              degree completed year <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              name="degreeCompletedYear"
              value={formData.degreeCompletedYear}
              onChange={e => handleChange(e)}
              disabled={disableInputFields}
              min="1900"
              max={currentYear}
              step="1"
              placeholder="e.g. 2024"
              pattern="[0-9]{4}"
              required
              style={{ width: '100%' }}
            />
            {disableInputFields ? (
              <span></span>
            ) : issavingData ? (
              <div className="loader"></div>
            ) : (
              <button
                type="submit"
                style={hasSavedAcademicInfo ? { background: "green" } : {}}
              >
                {hasSavedAcademicInfo ? "update" : "save"}
              </button>
            )}
          </div>

        </div>
      )}
    </form>
  );
};
